import type React from 'react';

import { Box } from '@mui/material';
import { useRecordContext } from 'react-admin';

import { getColor } from 'src/lib/colorUtils';

import type { SxProps } from '@mui/material';
import type { Calendar } from '@ragu-components/ord-types';

interface CalendarColorProps {
  size: string;
  sx?: SxProps;
}

export const CalendarColor = ({ size, sx = {} }: CalendarColorProps): React.ReactElement => {
  const record = useRecordContext<Calendar>();
  const id = record?.id;
  if (id === undefined) {
    return <></>;
  }
  return (
    <Box sx={{ borderRadius: `calc(${size} / 2)`, width: size, height: size, backgroundColor: getColor(id), ...sx }} />
  );
};
